import { useMutation } from "@tanstack/react-query";
import { logOut } from "../../../api/requests/logout";
import { useAuthStore } from "../../store/authStore";
import { useNotificationStore } from "@src/shared/components/Notification";

export const useLogOut = () => {
  const { showAlert } = useNotificationStore();
  const query = useMutation({
    mutationFn: logOut,
    onSuccess: () => {
      useAuthStore.getState().clearUser();
    },
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
